import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from "react";
import { Flex } from "@base-ui";
import { TabMenu, GraphSelector, RadioButtonFieldset } from "@interdependence-ui";
import { colorOptions } from "utils/colors";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox", "border"];
export default function GraphColorTabs(props) {
  var query = props.query,
    setQuery = props.setQuery;
  var tabs = [{
    id: "graph-select",
    label: "Diagramtyp"
  }, {
    id: "color-select",
    label: "Färg"
  }];
  var _useState = useState(tabs[0].id),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var _colorOptions = Object.values(colorOptions).map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      checked: option.id === query.colorSettings
    });
  });
  var handleGraphSelect = function handleGraphSelect(graphSelected) {
    return setQuery({
      graphSelected: graphSelected,
      sort: query.measureIds.length === 2 && graphSelected === "timeline" && ["asc", "desc"].includes(query.sort) ? "alpha" : query.sort
    });
  };
  var graphSelect = activeTab === "graph-select" && /*#__PURE__*/_jsx(Flex.Column, {
    id: "graph-select-panel",
    role: "tabpanel",
    "aria-labelledby": "graph-select",
    alignItems: "center",
    mt: "10px",
    children: /*#__PURE__*/_jsx(GraphSelector, {
      id: "measuredetail",
      selected: query.graphSelected,
      name: "measure-detail-graph-select",
      availableGraphs: ["timeline", "barchart"],
      onChange: handleGraphSelect
    })
  });
  var colorSelect = activeTab === "color-select" && /*#__PURE__*/_jsx(Flex.Column, {
    id: "color-select-panel",
    role: "tabpanel",
    "aria-labelledby": "color-select",
    mt: "10px",
    children: /*#__PURE__*/_jsx(RadioButtonFieldset, {
      id: "color-select-fieldset",
      legend: "V\xE4lj f\xE4rgschema f\xF6r grafen",
      name: "colorscheme",
      hideLegend: true,
      options: _colorOptions,
      updateSelected: function updateSelected(colorSettings) {
        return setQuery({
          colorSettings: colorSettings
        });
      }
    })
  });
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    p: "10px 20px"
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(TabMenu, {
      id: "graph+color-select",
      tabs: tabs,
      selected: activeTab,
      updateSelected: setActiveTab
    }), graphSelect, colorSelect]
  }));
}